import React, { useState, useEffect } from 'react';
import axios from 'axios';
import {Form} from 'react-bootstrap';

import Select from 'react-select';
import makeAnimated from 'react-select/animated';
const animatedComponents = makeAnimated();

function MListFilters(props) {
    const [lists, setLists] = useState([]);
    const [selectedList, setSelectedList] = useState([]);
    const [inputList, setInputList] = useState('');
  
    useEffect(()=>{
        getLists()
    },[props.listRefresh])

    const getLists = ()=>{
        const type = (props.mode==='businesses') ? 1 : 2;
        
        axios.get(`/lists/${props.loggedInUserId}/${type}`)
        .then(res => {
            setLists(res.data);
            
            if ((res.data.length > 0) && (props.myListId > 0)) {
                const myList = res.data.filter(o => o.value === props.myListId);
                if (myList.length > 0) {
                    onListChange(myList[0]);
                }
            }
        })
        .catch((error) => {
            console.log(error);
        }) 
    }
    
    const onListChange = (o) => {
        setSelectedList(o);
        props.pmlsl(o);
    }

    return (
        <div className="p-2 border border-gray">
            <div className="mb-3 d-flex flex-row business-step6 people-step4">
                <div style={{fontWeight: "700", fontSize: "13px"}}><i className="me-1 bi bi-person-lines-fill"></i>MY LISTS</div>
            </div>
            <Form id="frmMCatalogFilters" autocomplete="off">
                <div className="mb-2">
                    <Select
                        id='ctlList'
                        className="sm border border-primary rounded"
                        isMulti={false}
                        isClearable={true}
                        backspaceRemovesValue={true}
                        closeMenuOnSelect={true}
                        value={selectedList}
                        inputValue={inputList}
                        onChange={onListChange}
                        options={lists}
                        components={animatedComponents}
                        isDisabled={false}
                        menuPortalTarget={document.body}
                        styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                    />
                </div>
            </Form>
        </div>
    )
}

export default MListFilters;